import { render } from "./EditableXmlView.vue?vue&type=template&id=1af51a40&scoped=true"
import script from "./EditableXmlView.vue?vue&type=script&lang=js"
export * from "./EditableXmlView.vue?vue&type=script&lang=js"

import "./EditableXmlView.vue?vue&type=style&index=0&id=1af51a40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af51a40"]])

export default __exports__